<ng-container *ngIf="canAccess">
  <sales-report-search-card
    #searchCard
    [isOpen]="isSearchPanelOpen"
    [localStorageKey]="searchPanelLocalStorageKey"
    [canCreate]="canCreate"
    [canManage]="canExpand"
    (search)="searchSubject.next($event)"
    (loadingChange)="onLoadingChange($event)"
  ></sales-report-search-card>

  <sales-report-card
    [search]="search"
    [isLoading]="isLoading"
    [isReady]="isReady"
    [canManage]="canExpand"
    (expand)="searchCard.openExpandDialog()"
  ></sales-report-card>
</ng-container>
